export function heroSection() {
    const $window = $(window);
    const $heroVideo = $("#hero-video");
    const $heroVideoSource = $heroVideo.find("source");
    const $heroTitles = $(".title");
    const desktopSrc = $heroVideo.data("desktop-src");
    const mobileSrc = $heroVideo.data("mobile-src");
    if ($window.innerWidth() >= 1200) {
        $heroVideoSource.attr("src", desktopSrc);
    } else {
        $heroVideoSource.attr("src", mobileSrc);
    }
    $heroVideo[0].load();
    $heroVideo[0].play();
    $heroVideo.on("timeupdate", function () {
        let $time = this.currentTime * 1000;
        $heroTitles.each(function () {
            let $titleTime = parseInt($(this).attr("data-change-title"));
            if ($titleTime <= $time) {
                $(this).addClass("active");
                $(".title.active").not(this).removeClass("active");
            } else {
                $(this).removeClass("active");
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroSection.js